// import { DatePicker } from 'antd';
import React, { useState, useEffect } from "react";
import Select from "react-select";
import Axios from "axios";
import {
  API_BASE_URL,
  GET_PO_BY_ID,
  // GET_VSTORE_PROD,
  GET_STORE,
  INSERT_PURCHASE_ORDEDR,
  GET_TAXES_DATA,
  DELETE_PO_PRODUCT,
} from "../../../Config";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import SpinLoader from "../../../feature-module/loader/SpinLoader";

const EditPurchases = ({ POObj }) => {
  const [userDataSession, setUserDataSession] = useState([]);
  const [mainStoreId, setMainStoreId] = useState(0);
  const [mainStoreName, setMainStoreName] = useState("");
  // const [selectedDiscountType, setSelectedDiscountType] = useState(null);

  // #region Getting session😊
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    const supplierData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_Supplier")
    );
    const categoryData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_CATEGORY")
    );
    const unitsData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_UNITS")
    );
    // const storesData = JSON.parse(sessionStorage.getItem('filteredDDLData_Stores'));

    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
      // setStoreData(storesData);
      setUnitsData(unitsData);
      setCategoryData(categoryData);
      setSuppliersData(supplierData);
    } else {
      console.log("User data not found in sessionStorage");
    }
  }, []);

  const [categoryData, setCategoryData] = useState([]);
  const [storeData, setStoreData] = useState([]);
  const [unitsData, setUnitsData] = useState([]);
  const [suppliersData, setSuppliersData] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const [editProducts, setEditProducts] = useState([]);
  const [selectedStore, setSelectedStore] = useState(POObj?.StoreId || null);
  // const [selectedStatus, setSelectedStatus] = useState(null);
  const [discountType, setDiscountType] = useState(POObj?.DiscountType || null);
  const [enteredDiscount, setEnteredDiscount] = useState(
    POObj?.DiscountAmount || ""
  );
  // const [estimateAmount, setEstimateAmount] = useState(
  //   POObj?.EstimateAmount || ""
  // );
  const [submitLoading, setSubmitLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedExpecDate, setSelectedExpecDate] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [enterNotes, setEnterNotes] = useState("");
  const [inputValues, setInputValues] = useState([]);
  const [firstData, setFirstData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedTaxes, setSelectedTaxes] = useState({});
  const [taxesData, setTaxesData] = useState([]);
  const [totalAmount, setTotalAmount] = useState("");
  const [prodLoading, setProdLoading] = useState(false);

  useEffect(() => {
    if (POObj.Notes) {
      setEnterNotes(POObj.Notes);
    }
    console.log(POObj);
  }, [POObj]);

  useEffect(() => {
    if (POObj) {
      setEnteredDiscount(POObj.DiscountAmount || "");
      setDiscountType(POObj.DiscountType || null);
      setTotalAmount(POObj.EstimateAmount || null);
    }
  }, [POObj]);

  // Pre-select taxes based on TaxId from editProducts and taxesData
  useEffect(() => {
    if (editProducts.length > 0 && taxesData.length > 0) {
      const newSelectedTaxes = {};
      editProducts.forEach((prod, index) => {
        if (prod.TaxId) {
          const tax = taxesData.find((t) => t.Id === prod.TaxId);
          if (tax) {
            newSelectedTaxes[index] = {
              Id: tax.Id,
              TaxRate: tax.TaxRate,
              SGSTRate: tax.SGSTRate,
              CGSTRate: tax.CGSTRate,
              IGSTRate: tax.IGSTRate,
            };
          }
        }
      });
      setSelectedTaxes(newSelectedTaxes);
    }
  }, [editProducts, taxesData]);

  // #region getPurchaseRequestDetails 😊
  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && POObj && POObj.PurchaseId) {
      setLoading(true);
      Axios.get(`${API_BASE_URL}${GET_PO_BY_ID}?PurchaseId=${POObj.PurchaseId}`)
        .then((response) => {
          if (response.data.Status) {
            console.log(response.data.ResultData, "gettign po products");
            setEditProducts(response.data.ResultData);
            setFirstData(response.data.ResultData[0]);
            // setEnterNotes(response.data.ResultData[0]?.Notes);

            setLoading(false);
          } else {
            setLoading(false);
            setEditProducts([]);
            setFirstData([]);
            console.error("Error fetching dataddd:", response.data.Message);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching dataddsss:", error);
        });
    }
  }, [userDataSession, POObj]);

  useEffect(() => {
    setSelectedDate(
      POObj?.PODate ? new Date(POObj.PODate).toISOString().split("T")[0] : ""
    );
    setSelectedExpecDate(
      POObj?.PODate
        ? new Date(POObj.ExpectedDate).toISOString().split("T")[0]
        : ""
    );
    const supplier = suppliersData.find(
      (supp) => supp.ItemId === POObj?.SupplierId
    );
    if (supplier) {
      setSelectedSupplier({
        value: supplier.ItemId,
        label: supplier.ItemValue,
      });
    }
    const store = storeData.find((st) => st.Id === POObj?.StoreId);
    if (store) {
      setSelectedStore({
        value: store.Id,
        label: store.Name,
      });
    }
  }, [POObj]);

  useEffect(() => {
    const category = categoryData.find(
      (cat) => cat.ItemId === firstData?.CategoryId
    );
    if (category) {
      setSelectedCategory({
        value: category.ItemId,
        label: category.ItemValue,
      });
    }
  }, [firstData]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_TAXES_DATA}?OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data.Status) {
            setTaxesData(response.data.ResultData);
          } else {
            console.error("Error fetching data taxes:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data taxes catch:", error);
        });
    }
  }, [userDataSession]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && POObj && POObj.PurchaseId) {
      setLoading(true);
      Axios.get(
        `${API_BASE_URL}${GET_TAXES_DATA}?OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data.Status) {
            setTaxesData(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [userDataSession]);

  // useEffect(() => {
  //   const fetchData = () => {
  //     const requestData = {
  //       OrgId: userDataSession.OrgId,
  //       CategoryId: selectedCategory.value,
  //       BarCode: 0,
  //       ProductId: 0,
  //       StoreId: mainStoreId,
  //       IsForSale: 1,
  //       UserId: userDataSession.UserId,
  //       Type: 1,
  //     };

  //     // console.log(requestData, "storeprod data api sending");

  //     setProdLoading(true);
  //     Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
  //       .then((response) => {
  //         // Handle the response data as needed
  //         setProductsData(response.data.ResultData);
  //         setProdLoading(false);
  //       })
  //       .catch((error) => {
  //         setProductsData([]);
  //         console.error("Error fetching data:", error);
  //         setProdLoading(false);
  //       });
  //   };

  //   if (selectedCategory) {
  //     fetchData();
  //   }
  // }, [selectedCategory, userDataSession.OrgId, mainStoreId]);


    useEffect(() => {
    if (!userDataSession?.OrgId || !mainStoreId) return;
  
    const fetchProducts = async () => {
      setProdLoading(true);
      try {
        const params = {
          OrgId: userDataSession.OrgId,
          StoreId: mainStoreId,
          CategoryId: selectedCategory?.value || 0,
          ProductId: 0,           
        };
  
        const response = await Axios.get(`${API_BASE_URL}Product/ProductsDDL`, { params });
  
        if (response.data?.ResultData) {
          setProductsData(response.data.ResultData);
          console.log("Products loaded:", response.data.ResultData.length);
        } else {
          setProductsData([]);
        }
      } catch (error) {
        console.error("Failed to load products:", error);
        setProductsData([]);
        
      } finally {
        setProdLoading(false);
      }
    };
  
    fetchProducts();
  }, [userDataSession?.OrgId, mainStoreId, selectedCategory?.value]);
   
  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(`${API_BASE_URL}${GET_STORE}?OrgId=${userDataSession.OrgId}`)
        .then((response) => {
          if (response.data.Status) {
            const storesData = response.data.ResultData;
            setStoreData(storesData);
            const mainStore = storesData.find(
              (store) => store.IsMainStore === true
            );
            if (mainStore) {
              setMainStoreId(mainStore.Id);
              setMainStoreName(mainStore.Name);
              //   console.log(
              //     `Main Store ID: ${mainStore.Id}, Name: ${mainStore.Name}`
              //   );
            } else {
              console.log("No main store found");
            }
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  // const status = [
  //   { value: "DRAFT", label: "DRAFT" },
  //   { value: "ORDER", label: "ORDER" },
  //   { value: "INVOICE", label: "INVOICE" },
  //   { value: "RECEIVED", label: "RECEIVED" },
  //   { value: "REVISED", label: "REVISED" },
  //   { value: "CLOSED", label: "CLOSED" },
  // ];

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };
  const handleExpectedDateChange = (e) => {
    setSelectedExpecDate(e.target.value);
  };

  const handleCategoryChange = (selectedOption) => {
    setSelectedCategory(selectedOption);
  };

  const handleSupplierChange = (id) => {
    setSelectedSupplier(id);
  };
  const handleStoreChange = (id) => {
    setSelectedStore(id);
  };

  const handleAddProduct = (selectedOption) => {
    console.log("Products Data:", productsData);
    console.log("Selceted option", selectedOption);

    const selectedProduct = productsData.find(
      (prod) => prod.Id == selectedOption.value
    );

    console.log("Selected Product:", selectedProduct);

    if (!selectedProduct) {
      alert("Selected product is not valid.");
      return;
    }

    setEditProducts((prevProducts) => {
      const isProductExisting = prevProducts.some(
        (prod) => prod.Id === selectedProduct.Id
      );

      console.log("Edit Products:", prevProducts);
      console.log("Is Product Existing:", isProductExisting);

      if (isProductExisting) {
        alert("This product is already in the list.");
        return prevProducts;
      } else {
        return [
          ...prevProducts,
          {
            ...selectedProduct,
            Quantity: "",
            Comments: "",
            UnitPrice: null,
            Units: "",
            Tax: "",
          },
        ];
      }
    });
  };

  // #region Edit Submit 🥵
  const handleSubmit = (status, event) => {
    console.log(taxAmount);
    if (event) event.preventDefault();

    const requestPayload = {
      orgid: userDataSession.OrgId,
      userid: userDataSession.UserId,
      MainStoreId: mainStoreId,
      SupplierId: selectedSupplier?.value || POObj.SupplierId,
      PurchaseOrder: {
        Id: POObj.PurchaseId,
        StoreId: selectedStore?.value || POObj.StoreId,
        SupplierId: selectedSupplier?.value || POObj.SupplierId,
        Notes: enterNotes ? enterNotes : POObj?.Notes,
        POStatus: status,
        Status: POObj.PRStatus || null,
        PODate: selectedDate,
        ExpectedDate: selectedExpecDate,
        EstimateAmount: totalAmount || POObj.EstimateAmount,
        DiscountAmount: DiscountAmount || POObj.DiscountAmount,
        DiscountType: discountType ? discountType : POObj.DiscountType,
        DiscountPercent: enteredDiscount
          ? enteredDiscount
          : POObj.DiscountPercent,
        TaxAmount: discountType ? discountType : POObj.TaxAmount,
      },
      productdetails: editProducts?.map((prod, index) => ({
        detailid: prod.PurchaseDetailId ? prod.PurchaseDetailId : 0,
        ProductId: prod.ProductId ? prod.ProductId : prod.Id,
        Quantity: inputValues[index]?.Quantity || prod.Quantity,
        UOM: inputValues[index]?.Units || prod.UOM || null,
        UnitPrice: inputValues[index]?.UnitPrice || prod.UnitPrice,
        CGSTRate: selectedTaxes[index]?.CGSTRate || prod.CGSTRate || null,
        SGSTRate: selectedTaxes[index]?.SGSTRate || prod.SGSTRate || null,
        IGSTRate: selectedTaxes[index]?.IGSTRate || prod.IGSTRate || null,
        TaxId: selectedTaxes[index]?.Id || prod.TaxId || null,
      })),
    };

    console.log(requestPayload, "sending payload to api");

    setSubmitLoading(true);

    Axios.post(`${API_BASE_URL}${INSERT_PURCHASE_ORDEDR}`, requestPayload)
      .then((response) => {
        const data = response.data;
        if (data[0].Success == 1) {
          setSubmitLoading(false);
          Swal.fire({
            title: "Success",
            text: "Purchase order updated successfully.",
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to update purchase order.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        setSubmitLoading(false);
        console.error("Error:", error);
      });
  };

  // #region Delete
  const handleDelete = (item, index) => {
    if (!item.PurchaseDetailId) {
      setEditProducts((prevData) => prevData.filter((_, i) => i !== index));
      return;
    }

    const deleteData = {
      UserId: userDataSession.UserId,
      Id: item.PurchaseDetailId,
    };

    Axios.post(`${API_BASE_URL}${DELETE_PO_PRODUCT}`, deleteData)
      .then((response) => {
        if (response.data.ResultData[0].Status === "Success") {
          console.log("Product deleted successfully:", response.data);

          setEditProducts((prevData) => prevData.filter((_, i) => i !== index));
        } else {
          console.error("Failed to delete product:", response.data.Message);
          alert("Failed to delete product from the database.");
        }
      })
      .catch((error) => {
        console.error("Error deleting product:", error);
        alert("Error occurred while deleting the product.");
      });
  };

  const handleInputChange = (index, field, value) => {
    setInputValues({
      ...inputValues,
      [index]: {
        ...inputValues[index],
        [field]: value,
      },
    });
  };
  const handleUnitChange = (index, value) => {
    setInputValues({
      ...inputValues,
      [index]: {
        ...inputValues[index],
        Units: value,
      },
    });
  };

  const calculateAmount = (
    quantity,
    unitPrice,
    CGSTRate = 0,
    SGSTRate = 0
    // IGSTRate = 0
  ) => {
    const parsedQuantity = parseFloat(quantity) || 0;
    const parsedUnitPrice = parseFloat(unitPrice) || 0;

    // Calculate the total price without tax
    const baseAmount = parsedQuantity * parsedUnitPrice;

    // Calculate total tax rate
    const totalTaxRate = (CGSTRate + SGSTRate) / 100;

    // Calculate total tax amount
    const taxAmount = baseAmount * totalTaxRate;

    // Calculate the final amount including tax
    return (baseAmount + taxAmount).toFixed(2);
  };

  const handleTaxChange = (index, selectElement) => {
    if (selectElement.value === "") {
      setSelectedTaxes((prev) => {
        const newTaxes = { ...prev };
        delete newTaxes[index];
        return newTaxes;
      });
      return;
    }

    const selectedOption = JSON.parse(selectElement.value);
    const { Id, TaxRate, SGSTRate, CGSTRate, IGSTRate } = selectedOption;

    setSelectedTaxes((prev) => ({
      ...prev,
      [index]: {
        Id,
        TaxRate,
        SGSTRate,
        CGSTRate,
        IGSTRate,
      },
    }));
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "2.3rem",
      height: "2.3rem",
      padding: "0",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 0.5rem",
      display: "flex",
      alignItems: "center",
      height: "100%",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
      height: "100%",
    }),
    placeholder: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
      fontSize: "0.9rem",
      lineHeight: "1.2rem",
    }),
    singleValue: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
      fontSize: "0.9rem",
      lineHeight: "1.2rem",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0",
      height: "2.3rem",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "100%",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 10000,
    }),
  };

  const calculateTaxAmount = () => {
    return editProducts.reduce((totalTax, prod, index) => {
      const quantity = inputValues[index]?.Quantity || prod.Quantity || 0;
      const unitPrice = inputValues[index]?.UnitPrice || prod.UnitPrice || 0;
      const CGSTRate = selectedTaxes[index]?.CGSTRate || prod.CGSTRate || 0;
      const SGSTRate = selectedTaxes[index]?.SGSTRate || prod.SGSTRate || 0;

      const baseAmount = quantity * unitPrice;
      const taxRate = (CGSTRate + SGSTRate) / 100;

      return totalTax + baseAmount * taxRate;
    }, 0);
  };

  const taxAmount = calculateTaxAmount();

  const calculateDiscount = () => {
    if (discountType == 2) {
      // Percentage Discount
      const discountPercentage = parseFloat(enteredDiscount) || 0;
      return {
        DiscountPercent: discountPercentage,
        DiscountAmount: (discountPercentage / 100) * totalAmount,
      };
    } else {
      // Fixed Discount
      return {
        DiscountPercent: 0,
        DiscountAmount: parseFloat(enteredDiscount) || 0,
      };
    }
  };
  const { DiscountAmount } = calculateDiscount();

  useEffect(() => {
    let totalTaxAmt = 0;
    let totalAmount = 0;

    if (editProducts && editProducts.length > 0) {
      totalTaxAmt = editProducts.reduce((acc, product) => {
        const taxRate = product.CGSTRate + product.SGSTRate;
        const taxAmount =
          (product.UnitPrice * product.Quantity * taxRate) / 100;
        return acc + (taxAmount || 0);
      }, 0);

      totalAmount = editProducts.reduce((acc, product) => {
        const amount = product.UnitPrice * product.Quantity;
        return acc + (amount || 0);
      }, 0);
    }

    // setTaxAmount(totalTaxAmt);
    setTotalAmount(totalAmount + totalTaxAmt - POObj?.DiscountAmount);
  }, [editProducts]);
console.log(mainStoreName, "mainstoreName");
  return (<>{loading&&<SpinLoader/>}
    <div>
      {/* Edit Purchase */}
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasRightPOEdit {
            width: 95% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightPOEdit {
            width: 65% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightPOEdit {
            width: 65% !important;
          }
        }
          
        @media (min-width: 1441px)  {
          #offcanvasRightPOEdit {
            width: 50% !important;
          }
        }
        `}
      </style>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightPOEdit"
        aria-labelledby="offcanvasRightLabel"
        // style={{ minWidth: "65%", maxWidth: '65%' }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">
            Edit Purchase Order(
            <span className="text-primary">
              PO-{firstData ? firstData.AutoGenTransactionNo : ""}
            </span>
            )
          </h4>
          <h5 className="ms-5 text-primary ">
            {firstData ? firstData?.StoreName : ""}
          </h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>{" "}
        <hr />
        <div className="offcanvas-body">
          {loading ? (
            <div className="loader m-auto"></div>
          ) : (
            <form>
              <div className="row">
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="input-blocks add-product">
                    <label>Store</label>
                    <Select
                      className="select"
                      id="storeSelect"
                      styles={customStyles}
                      value={selectedStore}
                      onChange={handleStoreChange}
                      options={storeData?.map((store) => ({
                        value: store.Id,
                        label: store.Name,
                      }))}
                      placeholder="Choose store"
                    />
                        
                  </div>
                </div>  
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="input-blocks add-product">
                    <label>Supplier Name</label>
                    <div className="row">
                      <div className="col-lg-12 col-sm-12 col-12">
                        <Select
                          className="select"
                          id="categorySelect"
                          styles={customStyles}
                          value={selectedSupplier}
                          onChange={handleSupplierChange}
                          options={suppliersData?.map((supp) => ({
                            value: supp.ItemId,
                            label: supp.ItemValue,
                          }))}
                          placeholder="Choose supplier"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="input-blocks">
                    <label>Date</label>
                    <div className="input-groupicon calender-input">
                      <input
                        type="date"
                        className="form-control"
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="input-blocks">
                    <label>Expected Date</label>
                    <div className="input-groupicon calender-input">
                      <input
                        type="date"
                        className="form-control"
                        value={selectedExpecDate}
                        onChange={handleExpectedDateChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-3 col-md-3">
                  <div className="input-blocks">
                    <label>Category</label>
                    <Select
                      className="select"
                      id="categorySelect"
                      styles={customStyles}
                      value={selectedCategory}
                      onChange={handleCategoryChange}
                      options={categoryData?.map((cat) => ({
                        value: cat.ItemId,
                        label: cat.ItemValue,
                      }))}
                      placeholder="Choose Category"
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-3">
                  <div className="input-blocks">
                    <label>Products</label>
                    <Select
                      className="select"
                      styles={customStyles}
                      options={productsData?.map((prod) => ({
                        value: prod.Id,
                        label: prod.ProductName,
                      }))}
                      onChange={handleAddProduct}
                      placeholder={
                        prodLoading ? "Loading ..." : "Search products..."
                      }
                      isLoading={prodLoading}
                    />
                  </div>
                </div>
                <div className=" col-lg-3 col-md-3form-group">
                  <label className="form-label">Discount Type</label>
                  <select
                    className="form-select"
                    value={discountType}
                    onChange={(e) => setDiscountType(e.target.value)}
                    style={{ height: "2.3rem" }}
                  >
                    <option>Choose</option>
                    <option value="1">Fixed</option>
                    <option value="2">Percentage</option>
                  </select>
                </div>
                <div className="col-lg-3 col-md-3 form-group">
                  <label className="form-label">Discount</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter discount"
                    value={enteredDiscount}
                    onChange={(e) => setEnteredDiscount(e.target.value)}
                    onWheel={(e) => e.target.blur(e)}
                  />
                </div>
              </div>
              <div className="row mb-2 mt-2">
                <div className="col-lg-12">
                  <div className="modal-body-table">
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "20rem", overflowY: "auto" }}
                    >
                      <table className="table datanew">
                        <thead className="sticky-top">
                          <tr>
                            <th>#</th>
                            <th>Product</th>
                            <th>Quantity</th>
                            <th>Price</th>
                            <th>Units</th>
                            <th>Tax</th>
                            <th>Amount</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {editProducts.length !== 0 ? (
                            editProducts.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td title={item.ProductName}>
                                  {item.ProductName.length > 15
                                    ? `${item.ProductName.substring(0, 15)}...`
                                    : item.ProductName}
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Quantity"
                                    value={
                                      inputValues[index]?.Quantity ||
                                      item.Quantity
                                    }
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        "Quantity",
                                        e.target.value
                                      )
                                    }
                                    onWheel={(e) => e.target.blur(e)}
                                    style={{ width: "5rem" }}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    style={{ width: "6rem" }}
                                    value={
                                      inputValues[index]?.UnitPrice ||
                                      item.UnitPrice
                                    }
                                    className="form-control"
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        "UnitPrice",
                                        e.target.value
                                      )
                                    }
                                    onWheel={(e) => e.target.blur(e)}
                                  />
                                </td>
                                <td>
                                  <select
                                    className="form-select"
                                    value={
                                      inputValues[index]?.Units ||
                                      item.UOM ||
                                      "Choose"
                                    }
                                    onChange={(e) =>
                                      handleUnitChange(index, e.target.value)
                                    }
                                  >
                                    <option value="">Choose</option>
                                    {unitsData.map((unit) => (
                                      <option
                                        key={unit.ItemId}
                                        value={unit.ItemId}
                                      >
                                        {unit.ItemValue}
                                      </option>
                                    ))}
                                  </select>
                                </td>
                                <td>
                                  {/* <select
                                    className="form-select"
                                    value={
                                      selectedTaxes[index]
                                        ? JSON.stringify(selectedTaxes[index]) 
                                        : "Choose"
                                    }
                                    onChange={(e) =>
                                      handleTaxChange(index, e.target)
                                    }
                                  >
                                    <option>Choose</option>
                                    {taxesData?.map((tax) => (
                                      <option
                                        key={tax.Id}
                                        value={JSON.stringify({
                                          Id: tax.Id,
                                          TaxRate: tax.TaxRate,
                                          SGSTRate: tax.SGSTRate,
                                          CGSTRate: tax.CGSTRate,
                                          IGSTRate: tax.IGSTRate,
                                        })}
                                      >
                                        {tax.TaxRate}%
                                      </option>
                                    ))}
                                  </select> */}
                                  <select
                                    className="form-select"
                                    value={
                                      selectedTaxes[index]
                                        ? JSON.stringify(selectedTaxes[index])
                                        : ""
                                    }
                                    onChange={(e) =>
                                      handleTaxChange(index, e.target)
                                    }
                                  >
                                    <option value="">Choose</option>
                                    {taxesData?.map((tax) => (
                                      <option
                                        key={tax.Id}
                                        value={JSON.stringify({
                                          Id: tax.Id,
                                          TaxRate: tax.TaxRate,
                                          SGSTRate: tax.SGSTRate,
                                          CGSTRate: tax.CGSTRate,
                                          IGSTRate: tax.IGSTRate,
                                        })}
                                      >
                                        {tax.IGSTRate}%
                                      </option>
                                    ))}
                                  </select>
                                </td>
                                <td>
                                  {calculateAmount(
                                    inputValues[index]?.Quantity ||
                                      item.Quantity,
                                    inputValues[index]?.UnitPrice ||
                                      item.UnitPrice,
                                    selectedTaxes[index]?.CGSTRate ||
                                      item.CGSTRate,
                                    selectedTaxes[index]?.SGSTRate ||
                                      item.SGSTRate
                                  )}
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    className="btn text-danger"
                                    onClick={() => handleDelete(item, index)}
                                  >
                                    <i className="feather-trash-2 fs-6"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">
                                No Data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <table className="table">
                      <tfoot>
                        <tr>
                          <td colSpan="1" className="text-end fw-bold fs-6">
                            Total Discount:
                          </td>
                          <td className="fw-bold fs-5 text-primary">
                            {Number(DiscountAmount || 0).toFixed(2)}
                          </td>
                          <td colSpan="2" className="text-end fw-bold fs-6">
                            Total Tax:
                          </td>
                          <td className="fw-bold fs-5 text-primary">
                            {Number(taxAmount || 0).toFixed(2)}
                          </td>
                          <td colSpan="2" className="text-end fw-bold fs-6">
                            Total Amount:
                          </td>
                          <td className="fw-bold fs-5 text-primary">
                            {Number(totalAmount || 0).toFixed(2)}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="input-blocks">
                      <label>Shipment Details</label>
                      <textarea
                        placeholder="Enter notes"
                        onChange={(e) => setEnterNotes(e.target.value)}
                        value={enterNotes}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-auto d-flex justify-content-end p-3 sticky-bottom">
                <button
                  type="button"
                  className="btn btn-cancel me-2"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                  disabled={submitLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary me-2"
                  onClick={() => handleSubmit("DRAFT")}
                  disabled={submitLoading}
                >
                  {submitLoading ? "Submitting.." : "Save As Draft"}
                </button>
                <button
                  type="button"
                  className="btn btn-info me-2"
                  onClick={() => handleSubmit("PENDINGAPPROVAL")}
                  disabled={submitLoading}
                >
                  {submitLoading ? "Submitting.." : "Submit for Approval"}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div></>
  );
};

EditPurchases.propTypes = {
  POObj: PropTypes.object.isRequired,
};

export default EditPurchases;
